import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import loadable from "@loadable/component"
import NewsBtn from "gatsby-theme-starberry-lomondgroup/src/components/NewsBtn/NewsBtn";
//import ReactPaginate from 'react-paginate';
import {
    isTablet,
    isMobile
} from "react-device-detect";

import NewsCard from "gatsby-theme-starberry-lomondgroup/src/components/NewsCard";
import FeaturedLogo from "gatsby-theme-starberry-lomondgroup/src/components/FeaturedLogo/FeaturedLogo";
import {useWindowDimensions} from "gatsby-theme-starberry-lomondgroup/src/common/utils/site_utlis";

import "gatsby-theme-starberry-lomondgroup/src/components/ServiceCard/ServiceCard.scss"
import _ from "lodash";
import $ from 'jquery'

const ReactPaginate = loadable(() => import("react-paginate"));

const ServiceCard = ({ categories, news, GQLModules }) => {

    //let window_wdth = typeof window !== "undefined" && window.innerWidth;

    // const dimensions = useWindowDimensions();
    // const width = typeof window !== "undefined" && dimensions;  

    const [set, setClass] = useState(false);
    const handleShow = () => {
        setClass(!set);
    }

    const [filter, setFilter] = useState('all_categories');
    let [projects, setProjects] = useState(news);
    let [filteredList, setFilteredList] = useState(news);
    const [pageCount, setPageCount] = useState(0);
    // const itemsPerPage = width < 992 ? 13 : 14;
    const itemsPerPage = 12;
    const [itemOffset, setItemOffset] = useState(0);

    const newClass = (event) => {
        var parent = document.getElementById('filter-link');
        parent.classList.add('filter-active');
        setClass(false);
        var allChildElements = parent.querySelectorAll('.link-btn');
        for (const box of allChildElements) {
            box.classList.remove('active');
        }
        event.target.classList.add('active')
    }

    const applyCategory = (filt) => {
        setItemOffset(0)
        if (filt !== "all_categories") {
            setProjects([]);
            const filtered = _.filter(news, function (o) { return o.categories === filt; });
            setProjects(filtered);
            setFilteredList(filtered);
        } else {
            setProjects(news);
            setFilteredList(news);
        }
    }

    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setFilteredList(projects.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(projects.length / itemsPerPage));

        setTimeout(() => {
            window.scrollTo(0, 0);
        }, 500)
        
    }, [itemOffset, filter]);

    const handlePageClick = (event) => {
        //console.log("blog_test", event)

        const newOffset = (event.selected * itemsPerPage) % projects.length;

        //console.log("newOffset", newOffset)
        setItemOffset(newOffset);
    };

    //console.log("itemOffset", itemOffset)

    return (
        <>
            <section className="category">
                <Container>
                    <div className="category-wrap new-wrap">
                        <button onClick={handleShow}>{filter.replace(/_/g,' ')}
                            <i className="icon-dropdown"></i>
                        </button>

                    </div>
                    <div id="filter-link" className={set ? "category-wrap news-category open-category" : "category-wrap news-category"}>

                        {categories?.map((i, index) => (
                            <button key={index} className={index == 0 ? "link-btn active" : "link-btn"} onClick={(event) => {
                                setFilter(i); applyCategory(i); newClass(event);
                            }}>{i.replace(/_/gi, ' ')} </button>
                        ))}
                    </div>
                </Container>
            </section>

            {GQLModules?.length > 0 && GQLModules?.map((Module, index) => {
                return(
                    <>
                    {Module?.__typename === "GLSTRAPI_ComponentComponentsClientLogosComponent" &&   <FeaturedLogo key={Module} Module={Module} /> }
                    </>
                )
            })}

            <section className="service-card">
                <Container>
                    <Row>
                        <Col>
                            <div className="card-wrapper row">
                                {filteredList?.map((item, index) => {
                                    return (
                                        <>
                                            {/* {width < 992 ? (
                                                index < 1 ? 
                                                    <Col md={12} className="top-wrap">
                                                        <NewsCard item={item} imagename={"blog.tile_image.large_image"}/>
                                                    </Col>
                                                    : 
                                                    <Col md={6} lg={3} className="card-box">
                                                        <NewsCard item={item} imagename={"blog.tile_image.small_image"}/>
                                                    </Col>
                                                )
                                            :
                                                (    index < 2 ? 
                                                    <Col md={12} lg={6} className="top-wrap">
                                                        <NewsCard item={item} imagename={"blog.tile_image.large_image"}/>
                                                    </Col>
                                                    : 
                                                    <Col md={6} lg={3} className="card-box">
                                                        <NewsCard item={item} imagename={"blog.tile_image.small_image"} />
                                                    </Col>
                                                )

                                            } */}
                                            <Col md={6} lg={4}>
                                                <div className="card-box"><NewsCard NewsList={item} imagename={"blog.tile_image.large_image"}/></div>
                                            </Col>

                                            {
                                                index === 5 ?
                                                <Col md={12}><NewsBtn /></Col>
                                                : null
                                            }
                                        </>)
                                })}
                            </div>
                            {pageCount > 1 &&
                                <div className="pagination-section">
                                    <ReactPaginate
                                        breakLabel="..."
                                        nextLabel="next >"
                                        onPageChange={handlePageClick}
                                        pageRangeDisplayed={5}
                                        pageCount={pageCount}
                                        previousLabel="< previous"
                                        renderOnZeroPageCount={null}
                                        className="pagination"
                                        pageClassName="page-item"
                                        pageLinkClassName="page-link"
                                        previousClassName="prev page-item"
                                        previousLinkClassName="page-link"
                                        nextClassName="next page-item"
                                        nextLinkClassName="page-link"
                                        activeClassName="active"
                                    />
                                </div>
                            }
                        </Col>
                    </Row>
                </Container>
            </section>

        </>
    );
};
export default ServiceCard;
